export const NOTIFICATION_CONFIG = {
  DEFAULT_DURATION_MS: 5000,
  REMOVE_ANIMATION_DURATION_MS: 300
} as const
